export default "__VITE_ASSET__Dm49AGNo__"